import { FieldValue } from '../questionnaireHelpers';

const isNotBoolean = (value: FieldValue) =>
	typeof value !== 'boolean' && value !== 'false' && value !== 'true';

export default isNotBoolean;
